<template>
  <nav class="d-print-none" id="custom-navbar">
    <v-app-bar app dense>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer;" v-if="temporary"></v-app-bar-nav-icon>
      <v-app-bar-nav-icon @click.stop="goBack()" v-if="!temporary">
        <v-icon>mdi-arrow-left</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>{{$route.meta.toolbarTitle ? $route.meta.toolbarTitle : 'Toolbar Title'}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn> -->
      <v-btn icon @click="logout">
        <v-icon>mdi-logout-variant</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      color="primary"
      :permanent="permanent"
      :temporary="temporary"
      :width="setSidebarWidth"
    >
      <v-list-item @click="''">
        <v-list-item-avatar color="white" size="30">
          <v-img src="@/assets/default.png"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="white--text">Weld Visor</v-list-item-title>
        </v-list-item-content>

        <v-list-item-icon link>
          <v-icon color="white">mdi-dots-vertical</v-icon>
        </v-list-item-icon>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense class="app-main-drawer">
        <template>
          <div v-for="item in items" :key="item.title">
            <v-list-group v-if="item.items" v-model="item.active" no-action link color="white">
              <template v-slot:activator>
                <v-list-item-icon class="mr-2">
                  <v-icon v-text="item.icon" class="white--text"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.title" class="white--text"></v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="subItem in item.items"
                :key="subItem.title"
                :to="subItem.to"
                class="pl-14"
                exact
              >
                <v-list-item-content>
                  <v-list-item-title v-text="subItem.title" class="white--text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>

            <v-list-item v-else :to="item.to" @click="routeChange()" link color="white" exact>
              <v-list-item-icon class="mr-2">
                <v-icon v-text="item.icon" class="white--text"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.title" class="white--text"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-dialog v-model="displayMainLoader" fullscreen content-class="displayMainLoaderLayer">
    </v-dialog>
    <v-progress-linear indeterminate color="primary" v-if="displayMainLoader" fixed></v-progress-linear>
    <v-snackbar v-model="globalSnackbar" :top="true" :color="globalSnackbarContext.color" :timeout="2000">{{ globalSnackbarContext.text }}</v-snackbar>
  </nav>
</template>
<script>
export default {
  name: 'navbar',
  computed: {
    setSidebarWidth () {
      return this.temporary ? '85%' : '230'
    }
  },
  created () {
    this.$eventBus.$on('$changeAppTitle', (title) => {
      this.appTitle = title
    })

    this.$eventBus.$on('$displayMainLoader', (isLoading) => {
      this.displayMainLoader = isLoading
    })

    this.$eventBus.$on('$globalSnackbar', (color, text) => {
      this.globalSnackbarContext = { color: color, text: text }
      this.globalSnackbar = true
    })

    const currentRoute = this.$route.path
    const finalItems = []
    this.allItems.map((mainRoutes, mainIndex) => {
      if (mainRoutes.items !== undefined) {
        if (this.allItems[mainIndex].right !== undefined) {
          if (this.$checkRight(this.allItems[mainIndex].right)) {
            const child = []
            mainRoutes.items.map((childRoutes, childIndex) => {
              if (childRoutes.to === currentRoute) {
                this.allItems[mainIndex].active = true
              }
              if (this.allItems[mainIndex].items[childIndex].right !== undefined) {
                if (this.$checkRight(this.allItems[mainIndex].items[childIndex].right)) {
                  child.push(this.allItems[mainIndex].items[childIndex])
                }
              } else {
                child.push(this.allItems[mainIndex].items[childIndex])
              }
            })
            const finalChildItem = this.allItems[mainIndex]
            finalChildItem.items = child
            finalItems.push(finalChildItem)
          }
        } else {
          finalItems.push(this.allItems[mainIndex])
        }
      } else {
        if (this.allItems[mainIndex].right !== undefined) {
          if (this.$checkRight(this.allItems[mainIndex].right)) {
            finalItems.push(this.allItems[mainIndex])
          }
        } else {
          finalItems.push(this.allItems[mainIndex])
        }
      }
    })
    this.items = finalItems
  },
  data: function () {
    return {
      drawer: false,
      temporary: this.$vuetify.breakpoint.mdAndDown,
      permanent: !this.$vuetify.breakpoint.mdAndDown,
      displayMainLoader: false,
      globalSnackbar: false,
      globalSnackbarContext: {},
      items: [],
      allItems: [
        { title: 'Dashboard', icon: 'mdi-view-dashboard', to: '/dashboard' },
        {
          title: 'User',
          icon: 'mdi-account-circle',
          to: '/user',
          right: ['view_user', 'edit_user', 'view_user_role', 'edit_user_role'],
          items: [
            { title: 'User', to: '/user', right: ['view_user'] },
            { title: 'User Role', to: '/userRole', right: ['view_user_role'] },
          ]
        },
        /* {
          title: 'Company',
          icon: 'mdi-account-supervisor',
          to: '/user',
          items: [
            { title: 'Company', to: '/company' },
            { title: 'Company', to: '/company/create' }
          ]
        }, */
        {
          title: 'Machine',
          icon: 'mdi-toolbox',
          to: '/equipment',
          right: ['edit_equipment', 'view_equipment', 'view_machine', 'edit_machine', 'view_machine_maintenance', 'edit_machine_maintenance', 'view_machine_type', 'edit_machine_type'],
          items: [
            { title: 'Equipment', to: '/equipment', right: ['view_equipment'] },
            // { title: 'Equipment', to: '/equipment/create', right: ['edit_equipment'] },
            { title: 'Machine', to: '/machine', right: ['view_machine'] },
            { title: 'Machine Maintenance', to: '/machineMaintenance', right: ['view_machine_maintenance'] },
            { title: 'Machine Type', to: '/machineType', right: ['view_machine_type'] },
            { title: 'Live Status', to: '/machineLiveStatus', right: ['view_machine'] },
          ]
        },
        /* {
          title: 'Polarity',
          icon: 'mdi-chemical-weapon',
          to: '/polarity',
          items: [
            { title: 'Polarity', to: '/polarity' },
            { title: 'Polarity', to: '/polarity/create' }
          ]
        }, */
        /* {
          title: 'Qualification Method',
          icon: 'mdi-calendar-text',
          to: '/qualificationMethod',
          items: [
            { title: 'Qualification Method', to: '/qualificationMethod' },
            { title: 'Qualification Method', to: '/qualificationMethod/create' }
          ]
        }, */
        /* {
          title: 'Reffered Standard',
          icon: 'mdi-book',
          to: '/referredStandard',
          items: [
            { title: 'Reffered Standard', to: '/referredStandard' },
            { title: 'Reffered Standard', to: '/referredStandard/create' }
          ]
        }, */
        {
          title: 'Welder',
          icon: 'mdi-account-check',
          to: '/welder',
          right: ['view_welder', 'edit_welder'],
        },
        {
          title: 'Welding Procedure',
          icon: 'mdi-layers',
          to: '/weldingProcedure',
          right: ['view_welding_procedure', 'edit_welding_procedure', 'view_welding_type', 'edit_welding_type', 'view_welding_process', 'edit_welding_process', 'view_joint_type', 'edit_joint_type'],
          items: [
            { title: 'Welding Procedure', to: '/weldingProcedure', right: ['view_welding_procedure'] },
            { title: 'Welding Type', to: '/weldingType', right: ['view_welding_type'] },
            { title: 'Welding Process', to: '/weldingProcess', right: ['view_welding_process'] },
            { title: 'Joint Type', to: '/jointType', right: ['view_joint_type'] },
          ]
        },
        {
          title: 'Project',
          icon: 'mdi-server',
          to: '/project',
          right: ['view_project', 'edit_project'],
        },
        {
          title: 'Settings',
          icon: 'mdi-wrench',
          to: '/prefix',
          right: ['view_prefix', 'edit_prefix'],
          items: [
            { title: 'Prefix', to: '/prefix', right: ['view_prefix'] },
            { title: 'Company Profile', to: '/companyProfile', right: ['manage_company_profile'] },
          ]
        },
        {
          title: 'Reports',
          icon: 'mdi-checkbox-multiple-marked',
          to: '/cqaReport',
          right: ['cumulative_quality_analysis', 'machine_vise_quality_analysis', 'welder_analysis', 'cumulative_maintainance_analysis', 'project_cost_analysis', 'project_time_cost_quality_analysis', 'machine_usage_analysis'],
          items: [
            { title: 'Cumulative Quality Analysis', to: '/cqaReport', right: ['cumulative_quality_analysis'] },
            { title: 'Machine Vise Quality Analysis', to: '/mvqaReport', right: ['machine_vise_quality_analysis'] },
            { title: 'Welder Analysis', to: '/wlaReport', right: ['welder_analysis'] },
            { title: 'Cumulative Maintainance Analysis', to: '/cmaReport', right: ['cumulative_maintainance_analysis'] },
            { title: 'Project Cost Analysis', to: '/pcaReport', right: ['project_cost_analysis'] },
            { title: 'Project Time Cost Quality Analysis', to: '/ptcaReport', right: ['project_time_cost_quality_analysis'] },
            { title: 'Machine Usage Analysis', to: '/muaReport', right: ['machine_usage_analysis'] },
          ]
        },
      ]
    }
  },
  methods: {
    goBack () {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    },
    routeChange: function () {
      this.items.forEach(function (v) {
        if (v.active !== undefined) {
          v.active = false
        }
      })
    },
    callNavbarMethod: function () {
      console.log('call navbar method')
    },
    logout () {
      this.$userLoggedOut()
      this.$router.push('/login')
    }
  },
}
</script>
<style lang="scss">
#custom-navbar {
  .app-main-drawer
  .v-list-item__icon.v-list-group__header__append-icon
  .v-icon.notranslate.mdi.mdi-chevron-down.theme--light {
    color: #fff !important;
  }
  .v-icon.v-icon {
    font-size: 20px;
  }
  .v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
    min-width: 22px;
    margin-left: 0px;
  }
  .v-list--dense .v-list-item .v-list-item__title {
    font-size: 0.7925rem;
  }
}
.displayMainLoaderLayer {
  transition: unset !important;
}
</style>
